// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Caption-module--bx--text-truncate--end--VR7QD";
export var bxTextTruncateFront = "Caption-module--bx--text-truncate--front--g3mrG";
export var caption = "Caption-module--caption--EpycB";
export var captionResponsive = "Caption-module--caption-responsive--lWy64";